const FAQS = [
  {
    q: "How quickly can you start new support services?",
    a: "Because we are a responsive, local team, we can typically arrange an intake meeting within 24 to 48 hours and begin services as soon as support agreements are approved.",
  },
  {
    q: "Can you help with domestic and general household tasks?",
    a: "Yes. We assist with cleaning, laundry, meal preparation, shopping, and everyday domestic chores as part of your Core Supports budget.",
  },
  {
    q: "Do you service regional South Australia?",
    a: "Yes, our support coordinators and mobile workers operate across Adelaide, the Adelaide Hills, Barossa, Fleurieu Peninsula, and regional communities statewide.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 px-5 sm:px-8 bg-[#FAF8F5] border-t border-[#EAE3D8]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-2">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Frequently Asked Questions</span>
          <h2 className="text-2xl sm:text-3xl font-display font-medium text-[#1E282D]">Helpful information for SA participants & coordinators</h2>
        </div>
        <div className="space-y-4">
          {FAQS.map((f) => (
            <div key={f.q} className="p-5 rounded-2xl bg-[#F6F1EA] border border-[#E5DCCE] space-y-2">
              <h4 className="text-base font-semibold text-[#1E282D]">{f.q}</h4>
              <p className="text-sm text-[#4E5B62] leading-relaxed">{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
